module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "achievement"
  }, [_c('transition', {
    attrs: {
      "name": "modal-transition"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "achievement__wrap",
    on: {
      "click": _vm.close
    }
  }, [_c('celebration', {
    attrs: {
      "color": _vm.badge.color
    }
  }), _c('div', {
    staticClass: "achievement__icon-wrap"
  }, [_c('img', {
    staticClass: "achievement__icon",
    attrs: {
      "src": ("/build/img/badges/badge-" + _vm.type + "-color-384x.png")
    }
  })]), _c('div', {
    staticClass: "achievement__container",
    on: {
      "click": function($event) {
        $event.stopPropagation()
      }
    }
  }, [_c('h2', {
    staticClass: "achievement__title"
  }, [_vm._v(_vm._s(_vm.encouragement()) + " gedaan!")]), _c('p', {
    staticClass: "achievement__description"
  }, [_vm._v("Je hebt een bekroning gekregen voor "), _c('strong', [_vm._v(_vm._s(_vm.badge.name))])]), _c('primary-button', {
    on: {
      "clicked": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.thanks()))])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7401a288","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Achievement.vue
// module id = lSE2
// module chunks = 1